const $ = require('jquery');

module.exports = function ($timeout, $q) {
    function focus(elementOrCb) {
        // If the element passed was a function, execute the function.
        const element = typeof elementOrCb === 'function' ? elementOrCb() : elementOrCb;

        // Use the jquery object passed, or select one.
        const $element = element instanceof $ ? element : $(element);
        if ($element.length) {
            // check to see if item can accept focus
            if (!$element.is(':focusable') && typeof $element.attr('tabindex') === 'undefined') {
                $element.attr('tabindex', '-1');
            }

            $element.focus();
        }
    }

    return function (elementOrCb, immediate = false) {
        return immediate
            ? $q.when(focus(elementOrCb))
            : $timeout(() => focus(elementOrCb), 0, false);
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/movefocus/movefocus-factory.js